// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horStack > * {
    align-self: center;
}

.mappingArrow {
    margin: auto 8px;
}

.mapSelect {
    width: 250px;
}

.selectAllCB {
    font-weight: bold;
    margin: 0px 0px 7px 4px;
}

.scrollDIV {
    padding: 4px 0px;
}

.colCB {
    margin: 4px;
}`, "",{"version":3,"sources":["webpack://./src/app/workflow/modules/dataoperations/exportdata/exportdata.settings.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf","sourcesContent":[".horStack > * {\n    align-self: center;\n}\n\n.mappingArrow {\n    margin: auto 8px;\n}\n\n.mapSelect {\n    width: 250px;\n}\n\n.selectAllCB {\n    font-weight: bold;\n    margin: 0px 0px 7px 4px;\n}\n\n.scrollDIV {\n    padding: 4px 0px;\n}\n\n.colCB {\n    margin: 4px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
